export default function objectPick(data: Record<string, {}>, fields: string[]): {} {
  return Object.keys(data)
    .filter(key => fields.includes(key))
    .reduce(
      (accumulator: Record<string, {}>, key) => {
        accumulator[key] = data[key];
        return accumulator;
      },
      {},
    );
}
